import { useState } from "react";
import {
  UsersLoginPostRequest,
  ResponseCreateMstUserResponse,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiLoginUser = () => {
  const [loginUser, setLoginUser] =
    useState<ResponseCreateMstUserResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchLoginUser = async (
    tenantId: number,
    mail: string,
    password: string
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: UsersLoginPostRequest = {
        login: { tenantId, mail, password },
      };

      const api = new UsersApi(config);
      const response = await api.usersLoginPost(request);
      setLoginUser(response);

      // 認証トークンを保存（以降のリクエストの Authorization ヘッダに使用）
      if ((response as any)?.token) {
        localStorage.setItem("authToken", (response as any).token);
      }

      if ((response as any)?.loginHistoryId) {
        localStorage.setItem(
          "loginHistoryId",
          String((response as any).loginHistoryId)
        );
      } else {
        localStorage.removeItem("loginHistoryId");
      }

      return response;
    } catch (err: any) {
      console.error("Login error:", err);
      const status = err?.status ?? 0;
      if (status === 403) {
        setError("403");
      } else {
        setError("401");
      }
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { loginUser, fetchLoginUser, error, setError, isLoading };
};
